<template>
  <div id="forgetPwd">
    <div class="bg_style"></div>
    <div>
      <div id="logo"><img src="../assets/images/logo.png" alt=""></div>
      <div id="login_box">
        <div class="forgetPwd clearFix">
          <div class="login_left fl_l">
            <div class="login_l_title">
              <span class="active">找回密码</span>
            </div>
            <form action="javascript:;" id="login_from_yzm">
              
              <div class="login_l_tel clearFix">
                <div class="login_l_t_r w1 fl_r" :class="login_yzm_tel_errShow?'bor_red':''">
                  <el-input autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" name="mobile" maxlength="11" v-model="login_yzm_tel" placeholder="请输入手机号" @focus="login_yzm_tel_focus()" @blur="login_yzm_tel_blur()"></el-input>
                  <p class="login_tel_tips" v-if="login_yzm_tel_tips">验证完成后，可以使用该手机号登录或找回密码</p>
                  <p class="login_err_tips col_red" v-if="login_yzm_tel_errShow">{{login_yzm_tel_errMsg}}</p>
                </div>
              </div>
              <div class="login_l_pwd" :class="login_yzm_errShow?'bor_red':''">
                <el-input name="code" autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" v-model="login_yzm" placeholder="输入短信验证码" @focus="login_yzm_focus()" @blur="login_yzm_blur()"></el-input>
                <span class="login_l_getCode coutdown" :class="login_yzm_tel.length===11?'lightText':''" v-if="getCodeBtn" @click="getCode()" >获取验证码</span>
                <span class="login_l_getCode coutdown" :class="login_yzm_tel.length===11?'lightText':''" v-else>倒计时<span>{{time}}</span>s</span>
                <p class="login_err_tips col_red" v-if="login_yzm_errShow">{{login_yzm_errMsg}}</p>
              </div>
              <div class="login_l_pwd" :class="login_pwd_errShow?'bor_red':''">
                <el-input autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" name="password" v-model="login_pwd" placeholder="输入登录密码" show-password @focus="login_pwd_focus()" @blur="login_pwd_blur()"></el-input>
                <p class="login_err_tips col_red" v-if="login_pwd_errShow">{{login_pwd_errMsg}}</p>
              </div>            
              <!-- <input type="text" name="authtype" value="PASSWORD" hidden> -->
              <div class="login_l_bottom">
                <el-button type="primary" :disabled="loginBtn_yzm" @click="submit_yzm()">确认修改</el-button>
                <button id="submit_yzm" hidden>提交</button>
                <div class="login_l_b_other clearFix">
                  <div class="login_l_b_o_right fl_r">
                    已有账号？<router-link :to="{path:'/',query: {fromProd: true,qrcode:false}}">登录</router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>    
        
    <a href="https://www.bigvisiontech.com/" target="_blank" id="footer">苏州比格威医疗科技有限公司荣誉出品</a>
  </div>
</template>
<script>
import { getCode } from '../api/api'
import { _debounce } from "@/js/debounce";
import { isEmpty, isMobileNum } from '@/js/common';
export default {
  name: 'ForgetPwd',
  data() {
    return {
      options: [
        {
          value: '1',
          label: '中国 +86'
        },
        {
          value: '2',
          label: '澳大利亚 +61'
        },
        {
          value: '3',
          label: '巴基斯坦 +92'
        },
        {
          value: '4',
          label: '龙须面'
        },
        {
          value: '5',
          label: '马拉西亚 +60'
        }
      ],
      login_yzm_tel: '',
      login_yzm: '',
      login_pwd: '',
      login_yzm_tel_tips: false,
      login_yzm_tel_errShow: false,
      login_yzm_tel_errMsg: '',
      login_yzm_errShow: false,
      login_yzm_errMsg: '',
      login_pwd_errShow: false,
      login_pwd_errMsg: '',
      loginBtn_Pwd: false,
      loginBtn_yzm: false,
      getCodeBtn: true,
      time: 60
    }
  },
  created() {

  },
  methods: {
    // 手机号输入框focus
    login_yzm_tel_focus() {
      this.login_yzm_tel_tips = true
      this.login_yzm_tel_errShow = false
    },
    // 手机号输入框blur
    login_yzm_tel_blur() {
      this.login_yzm_tel_tips = false
      this.login_yzm_telCheck(this.login_yzm_tel)
    },
    // 校验--手机号输入框
    login_yzm_telCheck(tel) {
      if (isEmpty(tel)) {
        this.login_yzm_tel_errShow = true
        this.login_yzm_tel_errMsg = '手机号不为空'
        return false
      } else {
        if (isMobileNum(tel)) {
          return true
        } else {
          // this.login_yzm_tel = ''
          this.login_yzm_tel_errShow = true
          this.login_yzm_tel_errMsg = '手机号格式不正确'
          return false
        }
      }
    },
    // 获取验证码
    getCode() {
      if (this.login_yzm_telCheck(this.login_yzm_tel)) {
        this.coutDown()
        this.getCodeBtn = false
        console.log('tel: ', this.login_yzm_tel)
        getCode(this.login_yzm_tel).then(res => {
          console.log(res)
        })
      } else {        
        this.$message.error('请正确填写手机号')
      }
    },
    // 获取验证码--倒计时
    coutDown () {
        var that = this
        var timeClock = setInterval(function(){
            that.time--;                
        
            if (that.time == 0) {
                that.getCodeBtn = true
                clearInterval(timeClock);
                that.time = 60
            } 
        },1000)
    },
    // 验证码输入框focus
    login_yzm_focus() {
        this.login_yzm_errShow = false
        this.login_yzm_errMsg = ''
    },
    // 验证码输入框blur
    login_yzm_blur() {
      this.login_yzmCheck(this.login_yzm)
    },
    // 校验--验证码输入框
    login_yzmCheck(code) {
      if (isEmpty(code)) {
        this.login_yzm_errShow = true
        this.login_yzm_errMsg = '验证码不为空'
        return false
      } else {
        this.login_yzm_errShow = false
        this.login_yzm_errMsg = ''
        return true
      }
    },
    // 账号密码输入框focus
    login_pwd_focus() {
      this.login_pwd_errShow = false
      this.login_pwd_errMsg = ''
    },
    // 账号密码输入框blur
    login_pwd_blur() {
      this.login_pwdCheck(this.login_pwd)
    },
    // 校验--账号密码
    login_pwdCheck(val) {
      if (isEmpty(val)) {
        this.login_pwd_errShow = true
        this.login_pwd_errMsg = '密码不为空'
        return false
      } else {
        this.login_pwd_errShow = false
        this.login_pwd_errMsg = ''
        return true
      }
    },
    // 提交--验证码登录
    submit_yzm: _debounce(function () {     
      console.log('submit_yzm')
      if (this.login_yzm_telCheck(this.login_yzm_tel) && this.login_yzmCheck(this.login_yzm) && this.login_pwdCheck(this.login_pwd)) {
        var doc = document.getElementById("submit_yzm");
        doc.click()
      }
    }),
  }
}
</script>
<style scoped>
@import url('../assets/css/base.css');
@import url('../assets/css/login.css');
.login_l_b_o_right {
  color: #969696;
}
</style>